import { render } from "./FeaturedNFTArtworks.vue?vue&type=template&id=105dd85c&ts=true"
import script from "./FeaturedNFTArtworks.vue?vue&type=script&lang=ts"
export * from "./FeaturedNFTArtworks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__